module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-video"
  }, [_c('video', {
    ref: "videos",
    attrs: {
      "width": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fb36c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/GoodsVideo.vue
// module id = 2489
// module chunks = 0